import { PaymentsStateInterface } from './initialState.interface';

export const paymentsInitialState: PaymentsStateInterface = {
  loading: false,
  alertType: null,
  error: null,
};
